import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ComboServices } from '../../../combo/services';

/**
 * Generated class for the PhotoComboPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'photo-combo',
  templateUrl: 'photo-combo.html',
})
export class PhotoComboPage {
  @Input() photo_width:string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public comboServices: ComboServices) {
  }


  stylePhoto() {
    let styles = {
      'width': this.photo_width+' !important;',
      'max-height': '300px'
    };

    return styles;

  }


}



// WEBPACK FOOTER //
// ./src/pages/components/photo/photo-combo/photo-combo.ts